// START Open Requre.JS wrapper
define([
	"require",
	"jquery",
	'shared.main.screen',
	"wcs.mini-list",
	"wcs.mobile-panel",
	"wcs.context",
	"wcs.alert",
	'handlebars-loader',
	"promise!wcs.lang-msg",
	"pubsub",
	'promise!wcs.zmetrics'
], function(require, $, screenSize, miniList, mobilePanel, ctx, dialogAlert, HBLoader) {
// END Open Require.JS wrapper

/****
* Minicart provides the sidebar and top nav minicart and wishlist
***/

	var PLUGIN_IDENTIFIER = "minicart";
	var DEBUG = false;

	var minicart = function(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = options;


		// This next line takes advantage of HTML5 data attributes
		// to support customization of the plugin on a per-element
		// basis. For example,
		// <section class='componentname' data-menu-button-options='{
		//		"showLessText" : "Show Less",
		//		"showMoreText" : "Show More",
		//		"exposeCount" : 4
		//	}'>></section>
		this.metadata = $(this.element).data('minicart-options');
	};

	minicart.prototype = {
		defaults: {
			wishlistPanel: '#wishlist-notification-panel',
			topnav: '.topnav-header',
			topnavWrapper: 'div.topnav',
			cartWishlistPanel: '.global-cart-wishlist-panels-js, .topnav-minicart-panel',
			cmsTopNavMiniCart: '.topnav-minicart',
			rightMiniCartPanel: '.mini-cart-section.l-right',
			//In order for minicart messages to be generated, need minicart-message.js
			minicartMessage: {
				template: "html.mini-cart.messaging",
				cartPanelNotification: '.global-cart-wishlist-panels-js .notification, .topnav-minicart-panel .notification',
				wishlistPanelNotification: '#wishlist-notification-panel .notification',
				loadParameters: {
					target: '.global-cart-wishlist-panels-js .notification, .topnav-minicart-panel .notification',
					pluginFN: 'minicartMessage',
					requireModule: 'minicart-message'
				}
			}
		},

		/**
		* Initialize Minicart Functions
		**/
		init : function() {
			if(DEBUG) console.log('Initilizing minicart functions');

			this.config = $.extend({}, this.defaults, this.options, this.metadata);

			var self = this; // Make plugin namespace available throughout

			//cache variables
			self.isCMSTopNav = (self.element === $(self.config.topnavWrapper)[0]);
			self._miniCartLocation = WCS_CONFIG.get("global::miniCartLocation");
			self._cmsTopNavRightMiniCart = WCS_CONFIG.get("global::cmsTopNavRightMiniCart");
			self.autoHideTime = parseInt(WCS_CONFIG.get('global::miniCartAutoHideTime'));
			self.mobileShowAsModal = WCS_CONFIG.get("global::miniCartMobileShowAsModal");
			self.miniCartMobileTopScrollEnabled = WCS_CONFIG.get("global::miniCartMobileTopScrollEnabled");
			self.mobileApplePayButtonEnabled = WCS_CONFIG.get("applePay::applePayPDPMobileCTAEnabled");
			self.overlayVisible = false;
			self.manuallyClosed = false;
			self.disableMiniCart = ($('body').data('disableMiniCart')) ? $('body').data('disableMiniCart') : false;

			self.isSmallScreen = function(){
				return screenSize.size() === 'small';
			};
			self.notificationTimer = '';

			self._build();


			// top mini cart if location is top or is the cms top nav
			self.isTopMiniCart = (self._miniCartLocation === 'top' || ( self.isCMSTopNav && self._cmsTopNavRightMiniCart === false ));

			// cache these variables after _build() so the selectors are present on the page
			self.$globalCartWishlistPanels = $(self.config.cartWishlistPanel);
			self.$miniCartPanels = $("#global-cart-wishlist-panels, .topnav-minicart-panel");

			//Load minicart-message.js to generate messages via Handlebars
			new HBLoader(self.config.minicartMessage);

			$(document).on('click', '.continue-shopping-link', function(){
				$('#global-cart-wishlist-panels').addClass('hide');
			});

			//Suppress Mini Cart from initializing on Shopcart Page
			if($('.shopcart-js').length !== 0) {
				return;
			}

			// require top-panel js only if mini cart location === 'top'
			if (self.isTopMiniCart) {
				require(['wcs.top-panel'],function() {
					// initialize Minicart components and update the contents & display of the minicart based on events
					self.initializeMinicartComponents();
					self.updateContentEvents();
					if(!self.disableMiniCart) self.minicartUpdateShopcartEvents();
				});
			} else {
				self.initializeMinicartComponents();
				self.updateContentEvents();
				if(!self.disableMiniCart) self.minicartUpdateShopcartEvents();
			}

			self.events();

			return self;
		},

		/**
		* Minicart events
		**/
		events: function() {
			var self = this;

			// Add global click handler to body for handling updates from ajax calls
			$('body').on('click', self, self.miniCartGlobalClickHandler);
		},

		/**
		* Initialize toppanel and miniList
		**/
		initializeMinicartComponents: function() {
			var self = this;

			// if small screens initialize mobile panel
			if (self.isSmallScreen()) {
				mobilePanel.init();
			} else {
				// if not small screens
				if (!self.isTopMiniCart) {
					// otherwise is right minicart, require right right-panel and initialize minilist
					require(['wcs.right-panel'],function(rightPanel) {
						self.$globalCartWishlistPanels.rightPanels();
					});
				}
			}
		},

		/**
		* Show Mini Cart Panel/Notification --
		* mini cart.js only controls showing/hiding of small screen added to cart notification
		* it does not control hiding/showing of top/right mini cart panel
		* this happens in top-panel and right-panel
		**/
		showMinicartPanel: function() {
			if(DEBUG) console.log('showMinicartPanel()');
			var self = this;
			if (self.isSmallScreen()) {
				self.toggleOverlay();
				self.$globalCartWishlistPanels.find('.notification').removeClass('hide');
				self.$globalCartWishlistPanels.removeClass('hide');
				if (!self.isTopMiniCart) {
					self.$globalCartWishlistPanels.show();
				}

				if (self.miniCartMobileTopScrollEnabled) {
					$("html,body").animate({ scrollTop: 0 }, "fast");
				}

				$.pubsub('publish', 'vfdp.wcs.minicart.mobile_notification_panel_opened');
			} else {
				if (!self.isTopMiniCart) {
					self.$globalCartWishlistPanels.show();
				}
				self.$globalCartWishlistPanels.removeClass('hide');
			}
		},

		/**
		* Hide Mini Cart Panel/Notification --
		* mini cart.js only controls showing/hiding of small screen added to cart notification
		* it does not control hiding/showing of top/right mini cart panel
		* this happens in top-panel and right-panel
		**/
		hideMinicartPanel: function() {
			if(DEBUG) console.log('hideMinicartPanel()');
			var self = this;
			if (self.isSmallScreen()) {
				self.$globalCartWishlistPanels.find('.notification').addClass('hide');
				if (self.isTopMiniCart) {
					self.$globalCartWishlistPanels.addClass('hide');
				} else {
					self.$globalCartWishlistPanels.fadeOut();
				}
				self.toggleOverlay();
			} else {
				if (!self.isTopMiniCart) {
					self.$globalCartWishlistPanels.hide();
				}
				self.$globalCartWishlistPanels.addClass('hide');
			}
		},


		/**
		 * Get the product name from the data
		 *
		 * @param {Object} data containing product details
		 *  {
		 *	  product: {
		 *	    bundleId: <product bundle id>,
		 *	    itemId: <product item id>,
		 *	    name: <product name>,
		 *	    productId: <product id>,
		 *	  }
		 *	}
		 * @return {string} Product Name
		 **/
		getProductName: function(data) {
			var self = this;

			data = data || {};

			// Get the product data from the event
			if(Array.isArray(data.product)) {
				// If events send more than one product, use just the first
				return data.product[0].name;
			} else if(typeof data.product === 'object' && typeof data.product.name === 'string') {
				// If only one product is passed
				return data.product.name;
			}
		},

		/**
		* Mini cart update shopcart events
		**/
		minicartUpdateShopcartEvents: function() {
			if(DEBUG) console.log('minicartUpdateShopcartEvents()');
			var self = this;

			$.pubsub('subscribe','SHOPCART_UPDATED', function(msg, data) {
				data = data || {};

				var productName = self.getProductName(data);

				if (self.isSmallScreen()) {
					if (!mobilePanel.shopcartUpdateCheck) {
						return;
					}
				} else {
					if (data.action === 'delete') {
						self.showRemoveItemMessage();
						return;
					}
				}

				if (self.isSmallScreen()) {

					self.manuallyClosed = false;

					clearTimeout(self.notificationTimer);
					self.showMinicartPanel();

					// assign the close button functionality after rendering
					$(self.$globalCartWishlistPanels).one('click', '.mini-cart-icon-close-js', function() {

						if (self.isTopMiniCart) {
							self.$globalCartWishlistPanels.addClass('hide');
						} else {
							self.$globalCartWishlistPanels.fadeOut();
						}

						self.toggleOverlay(true);
					});

					self.notificationTimer =
						setTimeout(
							function() {
								self.hideMinicartPanel();
							},
						self.autoHideTime);
				}
			});
		},

		updateContentEvents: function() {
			if(DEBUG) console.log('updateContentEvents');
			var self = this,
				productName,
				$notification;

			// listen for wishlist updates and display messages in minicart accordingly
			$.pubsub('subscribe','WISHLIST_UPDATED', function(msg, data) {
				if (data === 'delete') {
					self.showRemoveItemMessage();
				} else {
					/** wishlist notification visible for mobile only.
					- right panel doesn't show notifications at all
					- top panel shows add/remove notification only
					**/
					if (self.isSmallScreen()) {
						$notification = $('.notification', self.config.wishlistPanel);

						clearTimeout(self.notificationTimer);
						$(self.config.wishlistPanel).show();
					}
				}
			});



			$.pubsub('subscribe', 'MINICART_CONTENT_RENDER_COMPLETE', function(msg, data) {
				// Setup any modals that can be launched from the minicart
				var $miniCartModals = $('.reveal', self.$miniCartPanels);

				if ($('*[data-open]', self.$miniCartPanels).length > 0) {
					// Move the modal containers out to the page DOM. Otherwise
					// they are destroyed when minicart is closed, which prevents
					// us from opening a modal when we hide the minicart.
					$miniCartModals.each(function(idx, el) {
						var $el = $(el);
						// Prevent duplicates by searching the DOM to ensure
						// the modal container wasn't already added previously
						if ($('body > #'+$el.attr('id')).length <= 0) {
							$('body').append($el);
						}
					});
				}

				/**
				 * Setup events that are fired on the AJAX-loaded minicart contents.
				 * When a share cart modal opens, Close minicart so we
				 *  don't have a modal and minicart showing at the same time
				 **/
				$('.share-cart-js', self.$miniCartPanels).on('click', function() {
					$('.tags .active', self.$miniCartPanels).trigger('click');
				});

				if (WCS_CONFIG.get('global::miniCartVisaCheckoutEnabled')) {
					$.pubsub('publish', 'VISA_CHECKOUT_CONTENT_READY');
				}

				if ($('.email-me-my-cart-form-container-js').length > 0) {
					require([ "wcs.email-me-my-cart"], function () {
						$('.email-me-my-cart-form-container-js').emailMeMyCart();
					});
				}

				if ($('.apple-pay-button').length > 0) {
					require(['wcs.applepay-button'], function() {
						$('.apple-pay-button').applePay();
					});
				}
			});

			//If EMMC is on page and mobile display
			if ($('.email-me-my-cart-form-js').length > 0 && self.isSmallScreen()) {
				$.pubsub('subscribe', 'ORDER_ID_UPDATED', function(message, data) {
					$('.email-me-my-cart-email-only-form.email-me-my-cart-form-js input[name="orderId"]').val(data.orderId);
				});
			}

			$.pubsub('subscribe', 'EMAIL_ME_MY_CART_ACTION', function() {
				clearTimeout(self.notificationTimer);
			});

			$.pubsub('subscribe', 'EMAIL_ME_MY_CART_FINISHED', function() {
				//Start Timer again when EMMC is finished/Closed/Not Active
				var $notification = self.$globalCartWishlistPanels.find('.notification');

				autoHideTimer = setTimeout(
					function() {
						self.hideMinicartPanel();
					},
				self.autoHideTime);
			});

			$.pubsub('subscribe', 'vfdp.wcs.free_gift.offer_loading', function() {
				// The free gift module is loading so close the side cart
				$('.cart-js.mini-cart-tag-shopcart.active').trigger('click');
			});

			$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_cart_succeeded', function() {
				// A product was successfully added to the shopping cart, open the side cart
				if (self._miniCartLocation === 'right' && screenSize.size() !== 'small') {
					$('.cart-js.mini-cart-tag-shopcart:not(.active)').trigger('click');
				}
			});

			$.pubsub('subscribe', 'vfdp.wcs.wishlist.add_to_cart_succeeded', function() {
				// A product was successfully added to the shopping cart, open the side cart
				if (self._miniCartLocation === 'right' && screenSize.size() !== 'small') {
					$('.cart-js.mini-cart-tag-shopcart:not(.active)').trigger('click');
				}
			});

			// Open the mini cart no matter what happens with the free gift
			$.pubsub('subscribe', 'vfdp.wcs.free_gift.offer_complete', function() {
				// A product was successfully added to the shopping cart, open the side cart
				if (self._miniCartLocation === 'right' && screenSize.size() !== 'small') {
					$('.cart-js.mini-cart-tag-shopcart:not(.active)').trigger('click');
				}
			});
		},

		showRemoveItemMessage: function() { // {wishlist | shopcart}
			var self = this;
			var $notification = self.$globalCartWishlistPanels.find('.notification');

			if(screenSize.size() !== 'small') {
					$('.minicart-sr-text-js').remove();
			}

			if (self.isTopMiniCart) {
				clearTimeout(self.notificationTimer);
				$notification.removeClass('hide');
			} else {
				$notification.addClass('show-for-sr').removeClass('hide');
			}
		},

		// Add to cart modal for small screens
		toggleOverlay: function(manuallyClosing) {
			if(DEBUG) console.log('toggleOverlay');
			//Check to see if global overlay is on page, if it is do nothing, if it isn't add to header
			if($('#global-body-overlay').length < 1) {
				$('header').append('<div id="global-body-overlay" title="Click to close"></div>');
			}

			var self = this,
				$globalBodyOverlay = $('#global-body-overlay');

			if (self.mobileShowAsModal || self.isCMSTopNav) {
				if (!self.manuallyClosed) {
					if (self.overlayVisible) {
						$globalBodyOverlay.fadeOut(500).delay(500).css({width: '0%'});
					} else {
						$globalBodyOverlay.hide().css({width: '100%'}).fadeIn(500);
					}
					if (manuallyClosing) {
						self.manuallyClosed = true;
					}
					self.overlayVisible = !self.overlayVisible;
				}
			} else {
				return;
			}
		},

		//Global click event handler
		// TODO: VFDP-23788 - This was written to listen to all click
		// events to get around the fact that the contents of the minicart
		// get replaced by AJAX calls. This is very inefficient as it
		// means they get evaluated on EVERY click event on EVERY page.
		// This needs to be rewritten to have targeted click events,
		// and to be reinitialized after every AJAX call to the minicart
		miniCartGlobalClickHandler: function(event) {
			if(DEBUG) console.log('miniCartGlobalClickHandler');
			var eventData = event.data,
				url,
				data,
				settings;
				$target = $(event.target);
			if ((eventData._miniCartLocation === 'right') && ($target.hasClass ('cart-js') && $target.hasClass ('active-js'))||($target.parents().hasClass ('cart-js') && $target.parents().hasClass ('active-js'))) {
				url = ACTION_URLS.MINI_SHOPPING_URL;
				data = {'storeId': ctx.getStoreId(), 'langId': ctx.getLangId(), 'catalogId': ctx.getCatalogId()};
				settings = {'title': LANG_MSG["DEAFULT_MINICART.SHOPPING.title"], 'page': 'shopcart', 'container': $('.global-cart-wishlist-panels-js .shopcart.cart-list')};
				miniList.renderMiniListItems (url, data, settings);
			}
			else if (($target.hasClass ('wishlist-js') && $target.hasClass ('active-js'))||($target.parents().hasClass ('wishlist-js') && $target.parents().hasClass ('active-js'))) {
				url = ACTION_URLS.MINI_WISHLIST_URL;
				data = {'storeId': ctx.getStoreId(), 'langId': ctx.getLangId()};
				settings = {'title': LANG_MSG["DEAFULT_MINICART.WISHLIST.title"], 'page': 'wishlist', 'container': $('.global-cart-wishlist-panels-js .wishlist.cart-list')};
				miniList.renderMiniListItems (url, data, settings);
			}
			else if ($target.parents(".remove-item-js").length > 0) {
				var $product = $target.parents(".cart-item-js").find(".cart-item-row"),
					 attributeStr = "";
				$product.find(".item-attr-js").each(function() {
					attributeStr += (attributeStr.length > 0 ? " / " : "") + $(this).text();
				});
				var parameters = {
					currency: WCS_CONFIG.get("global::currencyCode"),
					productName: $product.find(".item-name-js").text().replace(/^\s+|\s+$/gm,''),
					productId: $product.find(".product-info-js").data("partNumber"),
					itemId: $product.find(".product-info-js").data("itemPartnumber"),
					bundleId: $product.find(".product-info-js").data("bundlePartnumber"),
					styleCode: $product.find(".product-info-js").data("styleCode"),
					colorCode: $product.find(".item-attr-info-js").data("colorCode"),
					colorDescription: $product.find(".item-attr-info-js").data("colorDescription"),
					size: $product.find(".item-attr-info-js").data("size"),
					unitPrice: $product.find(".item-price-js").data("unitPrice"),
					definingAttributes: $.trim(attributeStr),
					quantity: $product.find(".item-qty-js").data("qty"),
					isProductRemoval: true
				};
				zm.trackRemovedItem(parameters);
			}
		},

		/**
		* Initial DOM modifications
		**/
		_build : function() {
			var self = this;

			// Add topnav mini cart html to cms topnav page
			if(self.isCMSTopNav && self._cmsTopNavRightMiniCart === false) {
				// if right nav panel already exists on cms topnav page --- remove it
				$(self.config.rightMiniCartPanel).remove();
				self._miniCartLocation = 'top';
				// if new topnav doesnt exist add it
				if($(self.config.cmsTopNavMiniCart).length === 0) {
					$(self.config.topnav).append(
						'<section class="topnav-minicart">'+
							'<div class="topnav-minicart-panel hide">'+
								'<div class="topnav-minicart-notification notification hide"></div>'+
								'<div class="topnav-minicart-content content">'+
									'<article class="topnav-minicart-content-container shopcart cart-list" data-tabcontent="shopcart"></article>'+
								'</div>'+
							'</div>'+
						'</section>');
				}
			}
		}
	};

	minicart.defaults = minicart.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.minicart = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if (!instance) {
				instance = new minicart(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};

});
// END close Require.JS wrapper
